import { useMemo, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { RbacRole, type PermissionEntry } from '../../constants'
import { getCurrentUserSelector } from '../slices/authentication-slice'

const isReadOnly =
  typeof window !== 'undefined' &&
  (window as unknown as Record<string, unknown>).__AXILON_READONLY__ === true

const usePermissions = () => {
  const currentUser = useSelector(getCurrentUserSelector)

  const userRoles = useMemo(() => {
    if (!currentUser?.roleAssignments) return [] as RbacRole[]
    return currentUser.roleAssignments.map((a) => a.role.name)
  }, [currentUser?.roleAssignments])

  const isGlobalAdmin = useMemo(
    () => !isReadOnly && userRoles.includes(RbacRole.GlobalAdmin),
    [userRoles]
  )

  const can = useCallback(
    (entry: PermissionEntry): boolean => {
      if (isReadOnly) return false
      if (isGlobalAdmin) return true
      return entry.roles.some((role) => userRoles.includes(role))
    },
    [userRoles, isGlobalAdmin]
  )

  return { can, isGlobalAdmin, userRoles }
}

export default usePermissions
